<template>
  <v-app>
    <v-main>
      <div class="content-wrapper">
        <!-- Content Header -->
        <div class="content-header">
          <div
            class="d-flex align-items-center"
            style="border-bottom: 1px solid #5c4a4a17; margin: auto !important"
          >
            <div class="row">
              <div class="col-12 d-flex flex-column align-items-baseline">
                <h1 class="m-0 text-dark">Roles Management</h1>
                <ol class="breadcrumb float-sm-left">
                  <router-link
                    tag="li"
                    class="breadcrumb-item"
                    :to="{ name: 'Home' }"
                    >Home</router-link
                  >
                  <router-link
                    tag="li"
                    class="breadcrumb-item"
                    :to="{ name: 'Dashboard' }"
                    >Dashboard</router-link
                  >
                  <li class="breadcrumb-item active">Roles Management</li>
                </ol>
                <div
                  class="position-absolute d-flex align-items-center h-100"
                  style="top: 0px; right: 142px; max-height: 200px;"
                >
                  <v-btn
                    class="width-fit-content mr-3"
                    style="height: 34px !important;"
                    @click="
                      entity = 'role';
                      dialog = true;
                    "
                    color="primary"
                    elevation="2"
                    x-small
                    >Create Role</v-btn
                  >
                </div>
                <div
                  class="position-absolute d-flex align-items-center h-100"
                  style="top: 0px; right: 11px; max-height: 200px;"
                >
                  <v-btn
                    class="width-fit-content"
                    style="height: 34px !important;"
                    @click="
                      entity = 'permission';
                      dialog = true;
                    "
                    color="primary"
                    elevation="2"
                    x-small
                    >Create Permission</v-btn
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Main Content -->
        <div class="row p-3">
          <!-- Search -->
          <!-- <div class="w-100">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              class="mb-3"
              style="width: 50%"
            ></v-text-field>
          </div> -->
          <div class="col-12">
            <!-- Action Buttons -->
            <!-- <div class="d-flex justify-content-end mb-6">
              <v-btn
                class="width-fit-content mr-3"
                style="height: 34px !important;"
                @click="
                  entity = 'role';
                  dialog = true;
                "
                color="primary"
                elevation="2"
                x-small
                >Create Role</v-btn
              >
              <v-btn
                class="width-fit-content"
                style="height: 34px !important;"
                @click="
                  entity = 'permission';
                  dialog = true;
                "
                color="primary"
                elevation="2"
                x-small
                >Create Permission</v-btn
              >
            </div> -->

            <!-- Table -->
            <v-data-table
              :headers="headers"
              :items="getRoles"
              :search="search"
              :loading="!getRoles.length || false"
              :expanded.sync="expanded"
              single-expand
              show-expand
              item-key="id"
              loading-text="Loading ..."
              class="elevation-1"
            >
              <template v-slot:[`item.name`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.name"
                  @save="editRole(item.id, item.name)"
                  @cancel="cancelEditDialog"
                  class="mt-4"
                >
                  {{ item.name }}
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.name"
                      single-line
                      counter
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>
              <!-- <template v-slot:[`item.sync_client`]="{ item }">
                <td class="pt-5 border-right text-center">
                  <v-select
                    :items="clients"
                    item-text="name"
                    item-value="id"
                    dense
                    multiple
                    :loading="!clients.length || false"
                  >
                    <template #append-item>
                      <v-list-action class="d-flex justify-center pt-3">
                        <v-btn
                          color="primary"
                          elevation="2"
                          plain
                          x-small
                          style="height: 27px !important"
                          @click.stop="
                            questionType = 'sync';
                            syncClients(item);
                          "
                          >Sync</v-btn
                        >
                      </v-list-action>
                    </template>
                  </v-select>
                </td>
              </template> -->
              <template v-slot:[`item.sync_permission`]="{ item }">
                <td class="pt-5 border-right text-center">
                  <v-select
                    v-model="item.permissions"
                    :items="permissions"
                    item-text="name"
                    item-value="id"
                    dense
                    multiple
                    :loading="!permissions.length || false"
                  >
                    <template #append-item>
                      <v-list class="d-flex justify-center pt-3">
                        <v-btn
                          color="primary"
                          elevation="2"
                          plain
                          x-small
                          style="height: 27px !important"
                          @click.stop="
                            questionType = 'sync';
                            syncPermissions(item);
                          "
                          >Sync</v-btn
                        >
                      </v-list>
                    </template>
                  </v-select>
                </td>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  @click="
                    id = item.id;
                    entity = 'role';
                    shwQuestion = true;
                  "
                  >mdi-trash-can-outline</v-icon
                >
              </template>
              <template v-slot:expanded-item="{ item }">
                <td
                  class="px-0 border-right text-center"
                  :class="[item.permissions.length ? 'pt-5' : 'pt-1']"
                >
                  <h6 class="border-bottom pb-2">Id</h6>
                  <p
                    v-for="(permission, i) in item.permissions"
                    :key="i"
                    :class="{
                      'mt-4': i === 0,
                    }"
                  >
                    {{ permission.id }}
                  </p>
                </td>
                <td
                  class="px-0 border-right text-center"
                  :class="[item.permissions.length ? 'pt-5' : 'pt-1']"
                >
                  <h6 class="border-bottom pb-2">Guard Name</h6>
                  <p
                    v-for="(permission, i) in item.permissions"
                    :key="i"
                    :class="{
                      'mt-4': i === 0,
                      'height-21': !permission.guard_name,
                    }"
                  >
                    {{ permission.guard_name }}
                  </p>
                </td>
                <td class="pt-1 px-0 text-center">
                  <h6 class="border-bottom pb-2">Name</h6>
                  <v-edit-dialog
                    v-for="(permission, i) in item.permissions"
                    :key="i"
                    :return-value.sync="permission.name"
                    @save="editPermission(permission.id, permission.name)"
                    @cancel="cancelEditDialog"
                    class="mt-4"
                  >
                    {{ permission.name }}
                    <template v-slot:input>
                      <v-text-field
                        v-model="permission.name"
                        single-line
                        counter
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="pt-16" style="width: 60px">
                  <p v-for="(permission, i) in item.permissions" :key="i">
                    <v-icon
                      @click="
                        id = permission.id;
                        entity = 'permission';
                        shwQuestion = true;
                      "
                      >mdi-trash-can-outline</v-icon
                    >
                  </p>
                </td>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>

      <!-- Question Pop Up -->
      <v-main></v-main>>
      <Question
        v-if="shwQuestion"
        @didClose="shwQuestion = false"
        @confirmed="
          remove(id, entity);
          shwQuestion = false;
        "
        @notConfirmed="remove(id, entity)"
        title="Are you sure?"
        text="You will delete it and won't be able to restore it."
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
        isConfirmedTitle="Deleted!"
        dismissTitle="Saved!"
        confirmButtonClasses="btn btn-success"
        cancelButtonClasses="btn btn-danger"
        successIcon="success"
        errorIcon="error"
      />

      <!-- Success Snackbar -->
      <transition
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated  animate__fadeOut animate__faster"
      >
        <SuccessSnackbar
          v-if="success"
          :message="successMessage"
          @update-success="handleUpdateToSuccessSnackbar"
        />
      </transition>

      <!-- Failure Snackbar -->
      <transition
        enter-active-class="animate__animated animate__fadeIn animate__faster"
        leave-active-class="animate__animated  animate__fadeOut animate__faster"
      >
        <FailureSnackbar
          v-if="failure"
          :message="failureMessage"
          @update-failure="handleUpdateToFailureSnackbar"
        />
      </transition>

      <!-- Dialog For Creating -->
      <dialog-window
        v-if="dialog"
        @closeDialogOutside="dialog = !dialog"
        @confirmed="create($event)"
        :entity="entity"
        :loading="processLoading"
      >
        <template #header> Create {{ entity }} </template>
        <template #disagreeBtnText>
          Cancel
        </template>
        <template #agreeBtnText>
          Create
        </template>
      </dialog-window>

      <!-- Error Pop Up -->
      <Error
        v-if="roleError || permissionError"
        :error="roleError || permissionError"
      />
    </v-main>
  </v-app>
</template>

<script>
import DialogWindow from "../popUps/DialogWindow.vue";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import Question from "../popUps/Question.vue";
import Error from "../popUps/Error.vue";
import common from "../../mixins/common";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "Roles",
  components: {
    DialogWindow,
    SuccessSnackbar,
    FailureSnackbar,
    Question,
    Error,
  },
  mixins: [common],
  data() {
    return {
      failureMessage: "",
      successMessage: "",

      success: false,
      failure: false,
      dialog: false,
      shwCreatePopUp: false,
      shwQuestion: false,

      questionType: "",

      id: null,
      entity: "",

      expanded: [],
      headers: [
        {
          text: "Role Name",
          value: "name",
          align: "start",
          sortable: false,
          divider: true,
          class: "table-header--color border-left",
          cellClass: "border-left"
        },
        // {
        //   text: "Permissions",
        //   value: "permissions",
        //   align: "center",
        //   sortable: false,
        // },
        // {
        //   text: "Sync Clients",
        //   value: "sync_client",
        //   align: "center",
        //   sortable: false,
        // },
        {
          text: "Sync Permission",
          value: "sync_permission",
          align: "center",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
        {
          value: "actions",
          align: "center",
          sortable: false,
          divider: true,
          class: "table-header--color",
        },
      ],

      loading: false,
      processLoading: false,

      search: "",
    };
  },
  computed: {
    ...mapState({
      //user: (state) => state.user.user,
      roles: (state) => state.roles.roles,
      clients: (state) => state.clients.clients,
      roleError: (state) => state.roles.roleError,
      permissions: (state) => state.permissions.permissions,
      permissionError: (state) => state.permissions.permissionError,
    }),
    ...mapGetters(["getRoles"]),
  },
  mounted() {
    this.getAllRoles();
    this.getAllPermissions();
    this.getAllClients();
  },
  methods: {
    ...mapActions([
      "getAllClients",
      "getAllRoles",
      "createRole",
      "updateRole",
      "removeRole",
      "getAllPermissions",
      "createPermission",
      "updatePermission",
      "removePermission",
    ]),

    runLoading() {
      this.processLoading = true;
      document.body.style.cursor = "wait";

      setTimeout(() => {
        this.processLoading = false;
        document.body.style.cursor = "default";
      }, 1000);
    },

    cancelEditDialog() {
      this.failureMessage = "Editing has been canceled";
      this.failure = true;
    },

    syncClients(obj) {
      this.updateRole({ id: obj.id, obj: obj }).then(() => {
        this.successMessage = "Client has been successfully synced!";
        this.success = true;
      });
    },

    syncPermissions(obj) {
      this.updateRole({ id: obj.id, obj: obj }).then(() => {
        this.successMessage = "Permission has been successfully synced!";
        this.success = true;
      });
    },

    editRole(id, name) {
      this.runLoading();

      this.updateRole({ id, name }).then(() => {
        this.successMessage = "Role has been successfully updated!";
        this.success = true;
      });
    },

    editPermission(id, name) {
      this.runLoading();

      this.updatePermission({ id, name }).then(() => {
        this.successMessage = "Permission has been successfully updated!";
        this.success = true;
      });
    },

    remove(id, entity) {
      this.runLoading();

      if (entity === "permission") {
        this.removePermission(id).then(() => {
          this.successMessage = "Permission has been successfully deleted";
          this.success - true;
        });
      } else if (entity === "role") {
        this.removeRole(id).then(() => {
          this.successMessage = "Role has been successfully deleted";
          this.success - true;
        });
      }
    },

    create(event) {
      this.runLoading();

      setTimeout(() => {
        this.dialog = false;
      }, 1000);

      if (event) {
        if (this.entity === "role") {
          let obj = new Object();
          obj.name = event;
          obj.permissions = [];

          this.createRole(obj).then(() => {
            this.successMessage =
              this.entity + " has been successfully created!";
            this.success = true;
          });
        } else if (this.entity === "permission") {
          let obj = new Object();
          obj.name = event;
          obj.roles = [];

          this.createPermission(obj).then(() => {
            this.successMessage =
              this.entity + " has been successfully created!";
            this.success = true;
          });
        }
      } else {
        this.failure = "Fill out the " + this.entity + " name";
        this.failure = true;
        this.processLoading = false;
      }
    },
  },
};
</script>

<style>
.no-border-bottom > .v-input__control > .v-input__slot:after,
.no-border-bottom > .v-input__control > .v-input__slot:before {
  width: 0 !important;
}
</style>
